import { ModifyAccessLevel } from './accessLevel.js';
import { ProductType } from '../data/productTypes.js';
import { IProductState } from '../db/product.js';
import { IProductBundleState } from '../db/userProductBundle.js';

export interface INewAccountLink {
  bundleToken: string;
  languages: Array<string>;
  bundleState: IProductBundleState;
  isProductLink: boolean;
  productState: IProductState;
  isGalleryAvailable: boolean;
  isShipmentAvailable: boolean;
  isBundleToConnect: boolean;
  googleToken: string;
  productType: ProductType;
  modifyAccessLevel: ModifyAccessLevel;
}

export class NewAccountLinkClass implements INewAccountLink {
  bundleToken: string;
  languages: Array<string>;
  bundleState: IProductBundleState;
  isProductLink: boolean;
  productState: IProductState;
  isGalleryAvailable: boolean;
  isShipmentAvailable: boolean;
  isBundleToConnect: boolean;
  googleToken: string;
  productType: ProductType;
  modifyAccessLevel: ModifyAccessLevel;

  constructor(newAccount?: Partial<INewAccountLink>) {
    this.bundleToken = newAccount?.bundleToken ?? '';
    this.languages = newAccount?.languages ?? ['pl']; // Default app language
    this.bundleState = newAccount?.bundleState ?? IProductBundleState.UNKNOW;
    this.isProductLink = newAccount?.isProductLink ?? false;
    this.productState = newAccount?.productState ?? IProductState.UNKNOW;
    this.isGalleryAvailable = newAccount?.isGalleryAvailable ?? false;
    this.isShipmentAvailable = newAccount?.isShipmentAvailable ?? false;
    this.isBundleToConnect = newAccount?.isBundleToConnect ?? false;
    this.googleToken = newAccount?.googleToken ?? '';
    this.isBundleToConnect = newAccount?.isBundleToConnect ?? true;
    this.productType = newAccount?.productType ?? ProductType.UNKNOW;
    this.modifyAccessLevel =
      newAccount?.modifyAccessLevel ?? ModifyAccessLevel.UNKNOW;
  }
}
